import * as _actions from './actions';
import * as _accessors from './accessors';
import _reducer from './reducer';
import _HomeworkType from './model';

_HomeworkType.actions = _actions;
_HomeworkType.accessors = _accessors;

export const actions = _actions;
export const accessors = _accessors;
export const reducer = _reducer;
const HomeworkType = _HomeworkType;
export default HomeworkType;



// WEBPACK FOOTER //
// ./data/Homework/Types/index.js